import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { defineMessages, injectIntl } from 'react-intl';

import differenceInSeconds from 'date-fns/difference_in_seconds';

const messages = defineMessages({
  format: {
    id: 'countdown-format',
    defaultMessage: '{hours} t {minutes} min',
  },
  formatSeconds: {
    id: 'countdown-format-seconds',
    defaultMessage: '{seconds} s',
  },
});

class Countdown extends Component {
  static propTypes = {
    intl: PropTypes.object.isRequired,
    target: PropTypes.instanceOf(Date),
    finished: PropTypes.node.isRequired,
    icon: PropTypes.bool,
    onEnd: PropTypes.func,
  };

  static defaultProps = {
    target: null,
    icon: false,
    onEnd: () => {},
  };

  state = {
    now: new Date(),
    onEndCalled: false,
  };

  componentDidMount() {
    this.interval = setInterval(() => {
      this.setState({ now: new Date() });
    }, 1000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  render() {
    const { formatMessage } = this.props.intl;
    const { target, finished, icon, onEnd } = this.props;
    const { now, onEndCalled } = this.state;

    if (!now || !target) return null;

    const seconds = differenceInSeconds(target, now);
    if (seconds < 0) {
      if (!onEndCalled) {
        onEnd();
        this.setState({ onEndCalled: true });
      }

      return finished;
    }

    const minutes = Math.floor((seconds % 3600) / 60);
    const hours = Math.floor(seconds / 3600);

    const message = seconds <= 60 ? messages.formatSeconds : messages.format;

    if (!icon) {
      return <span>{formatMessage(message, { hours, minutes, seconds })}</span>;
    }

    return (
      <div className="d-flex">
        <span className="text-nowrap">
          {formatMessage(message, { hours, minutes, seconds })}
        </span>

        <i className="far fa-clock fa-lg text-primary ml-2" />
      </div>
    );
  }
}

export default injectIntl(Countdown);
